export const SET_ITEM_TYPES = 'SET_ITEM_TYPES';
export const SET_ITEM_TYPE = 'SET_ITEM_TYPE';
export const ADD_ITEM_TYPE = 'ADD_ITEM_TYPE';
export const UPDATE_ITEM_TYPE = 'UPDATE_ITEM_TYPE';
export const REMOVE_ITEM_TYPE = 'REMOVE_ITEM_TYPE';
export const CLEAR_ITEM_TYPE = 'CLEAR_ITEM_TYPE';
export const CLEAR_ITEM_TYPES = 'CLEAR_ITEM_TYPES';
